import { Component } from "../../core/Component";
import { INITIAL_OBSTRUCTION_PROGRESS } from "../constants";

export class GerminateComponent extends Component {
	progress = INITIAL_OBSTRUCTION_PROGRESS;
}
